import React from "react"
import "./banner.css"

export class SchoolpageBannerContent extends React.Component {
  constructor(props) {
    super(props)

    this.state = {}
  }

  render() {
    const html = (
      <>
        <div className="banner-content">
          <div
            className="banner-content-background-new"
            style={{
              backgroundImage: `url(/banner-gradient-background-1.png)`,
            }}
          ></div>
          <div className="banner-title homepage-banner-title business-banner-title school-banner-title">
            See it...BEE it.
            <br />
            Career Connections in just 5 minutes a week.
          </div>
        </div>
      </>
    )
    return html
  }
}
